import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/heading-text.svg";
var HeadingTextSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  HeadingTextSolid_default as default
};
